import APIService from './APIService'

const api = APIService()

export const getReplenishmentTasks = payload => api.get(`/replenishment-tasks${payload.query}`)
